import { useState, useEffect } from 'react';

import { showError } from '@/shared';
import { useGetWithdrawalsQuery } from '../store/withdrawals-api';

import type { TGetWithdrawalsParams } from '../store/types';

const initialParams: TGetWithdrawalsParams = {
  pageSize: 30,
  page: 1,
  ascending: false,
};

export const useGetWithdrawals = () => {
  const [params, setParams] = useState<TGetWithdrawalsParams>(initialParams);
  const { data, isLoading, isError } = useGetWithdrawalsQuery(params);
  const itemsCount = data?.count;
  const items = data?.items ?? [];

  useEffect(() => {
    if (isError) {
      showError({ message: 'Произошла ошибка!' });
    }
  }, [isError]);

  const handleFilterChange = (data: TGetWithdrawalsParams) => {
    setParams({ ...initialParams, ...data });
  };

  const handleFilterReset = () => {
    setParams({ ...initialParams });
  };

  const handlePaginationChange = (page: number) => {
    setParams((prev) => ({
      ...prev,
      page,
    }));
  };

  return {
    params,
    items,
    itemsCount,
    isLoading,
    handleFilterChange,
    handleFilterReset,
    handlePaginationChange,
  };
};
